import { Stack } from "@mui/material";
import withHeightFitContent from "hocs/withHeightFitContent";
import useScrollMemory from "hooks/useScrollMemory";
import Content from "./Content";

const ContentWithHeightFitContent = withHeightFitContent(Content);

interface LeftColumnProps {
  isEditing: boolean;
  skillId: string | undefined;
  isMultiChoiceQuestion: boolean;
}

const LeftColumn = ({ isEditing, skillId, isMultiChoiceQuestion }: LeftColumnProps) => {
  const { ref } = useScrollMemory();

  return (
    <Stack spacing={2.5}>
      <ContentWithHeightFitContent
        skillId={skillId}
        isEditing={isEditing}
        isMultiChoiceQuestion={isMultiChoiceQuestion}
        refProp={ref}
      />
    </Stack>
  );
};

export default LeftColumn;
